export default function Hero() {
  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 bg-background-50 overflow-hidden">
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200/60 mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-semibold text-primary-700">Independent Educational Resource</span>
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-5">
            LitBuy Spreadsheet Guides
            <br />
            <span className="text-primary-600">&amp; Tracking Resources</span>
          </h1>

          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-8 leading-relaxed">
            Organize, track, and optimize your workflow with comprehensive LitBuy spreadsheet
            resources. Discover templates, guides, and best practices designed to help you
            manage data more effectively.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-7 py-3 text-sm font-bold bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap w-full sm:w-auto"
            >
              LitBuy Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center ml-2">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center px-7 py-3 text-sm font-bold border-2 border-primary-500 text-primary-600 rounded-full hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap w-full sm:w-auto"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center ml-2">
                <i className="ri-shopping-cart-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="relative mt-12 md:mt-16 w-full">
        <div className="w-full h-[300px] md:h-[420px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20modern%20desk%20workspace%20with%20laptop%20showing%20colorful%20data%20dashboard%20and%20spreadsheet%20analytics%20on%20screen%2C%20organized%20creative%20setup%20with%20notebook%20coffee%20cup%20and%20small%20potted%20succulent%20plant%2C%20soft%20natural%20window%20light%20from%20left%20side%2C%20light%20oak%20wood%20desk%20surface%2C%20cozy%20and%20productive%20atmosphere%2C%20clean%20aesthetic%20with%20gentle%20warm%20beige%20and%20cream%20tones%2C%20editorial%20lifestyle%20photography&width=1600&height=600&seq=hero-img-litbuy-2026-new&orientation=landscape"
            alt="LitBuy spreadsheet workspace with organized data management"
            title="LitBuy Spreadsheet Guides and Tracking Resources"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-background-50 via-transparent to-background-50 pointer-events-none"></div>
      </div>
    </section>
  );
}